import React from 'react'
import { Picture } from '@which/seatbelt'

import type { ImageWithSources } from '../../../../generated/frontend'

export const LegacyCTA = ({ image, url, linkAnchor }: LegacyCTAProps) => {
  if (!image?.src || !url || !linkAnchor) {
    return null
  }

  return (
    <a className="d-block my-4" href={url} id={linkAnchor} target="_blank">
      <Picture {...image} />
    </a>
  )
}

///////// IMPLEMENTATION /////////

type LegacyCTAProps = {
  image: ImageWithSources
  linkAnchor: string
  url: string
}
